import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useEffect, useMemo, useState } from 'react';
import { useTheme } from 'styled-components';
import { Icon } from '../../ui';
import { Tabs } from '../Tabs';
import { Navigation } from './Navigation';
import { StyledCollapseButtonContainer, StyledCollapseButtonWrapper, StyledCollapseInnerIcon, StyledContentContainer, StyledContentDrawer, StyledContentWrapper, StyledWrapper, StyledWrapperComponentTab, } from './ToolBar.style';
const WrapperComponentTab = memo(function WrapperComponentTab({ loaded, children, hasTabs, }) {
    if (!loaded)
        return null;
    return (_jsx(StyledWrapperComponentTab, { className: `menu-component ${hasTabs ? 'menu-component-tab' : ''}`, children: children }));
});
const MenuContent = memo(function MenuContent({ featuredItem, children, items, onClickMenuItem, type, variant, visible, }) {
    const [componentsMap, setComponentsMap] = useState({});
    const hasComponentOpened = useCallback((type) => componentsMap[type] || false, [componentsMap]);
    const menuItems = useMemo(() => [featuredItem, ...items].filter(Boolean), [featuredItem, items]);
    useEffect(() => {
        setComponentsMap((prevMap) => (Object.assign(Object.assign({}, prevMap), { [type]: true })));
    }, [type]);
    return (_jsxs(StyledContentWrapper, { visible: visible, variant: variant, children: [_jsx(StyledContentDrawer, { visible: visible, variant: variant, children: menuItems.map((item) => (_jsx(StyledContentContainer, { active: type === item.type, children: Array.isArray(item.children) ? (_jsx(WrapperComponentTab, { hasTabs: true, loaded: hasComponentOpened(item.type), children: _jsx(Tabs, { items: item.children.map(({ label, component }, index) => {
                                const key = `${item.type}-${label.replace(/\W/g, '').toLowerCase}`;
                                if (index === 0)
                                    componentsMap[key] = true;
                                return {
                                    label: label,
                                    content: (_jsx(WrapperComponentTab, { loaded: hasComponentOpened(key), children: component })),
                                    onClick: () => onClickMenuItem === null || onClickMenuItem === void 0 ? void 0 : onClickMenuItem(item),
                                };
                            }) }) })) : (_jsx(WrapperComponentTab, { loaded: hasComponentOpened(item.type), children: item.children })) }, `menu-tab-${item.type}`))) }), children] }));
});
export const ToolBar = ({ featuredItem, items, visible = false, activeSection, onClick, variant = 'static', onVisibilityChange, }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [section, setSection] = useState(activeSection || items[0].type);
    const theme = useTheme();
    const onCollapseButtonClick = useCallback((isVisible) => {
        setIsOpen((previous) => {
            const visible = isVisible !== null && isVisible !== void 0 ? isVisible : !previous;
            setTimeout(() => {
                setSection((prev) => (visible ? prev : ''));
            }, theme.Transition.Duration.Out);
            return visible;
        });
        onVisibilityChange(isVisible);
    }, [onVisibilityChange, theme.Transition.Duration.Out]);
    useEffect(function updateStateWhenPropChange() {
        onCollapseButtonClick(visible);
    }, [visible, onCollapseButtonClick]);
    useEffect(function updateActiveSectionWhenPropChange() {
        setIsOpen((isVisible) => {
            isVisible && activeSection && setSection(activeSection);
            return isVisible;
        });
    }, [activeSection, items]);
    return (_jsxs(StyledWrapper, { variant: variant, visible: isOpen, children: [_jsx(Navigation, { featuredItem: featuredItem, items: items, variant: variant, activeItem: section, visible: isOpen, onCollapse: () => onCollapseButtonClick(!isOpen), onClick: (item) => {
                    onClick === null || onClick === void 0 ? void 0 : onClick(item);
                    setSection(activeSection || item.type);
                } }), _jsx(MenuContent, { visible: isOpen, featuredItem: featuredItem, items: items, type: section, variant: variant, children: _jsxs(StyledCollapseButtonContainer, { variant: variant, visible: isOpen, onClick: () => onCollapseButtonClick(!isOpen), children: [_jsx(StyledCollapseButtonWrapper, { children: _jsx(Icon, { color: theme.Components.Panel.Background, name: 'menu-colapse---16', size: "XXLarge" }) }), _jsx(StyledCollapseInnerIcon, { children: _jsx(Icon, { color: theme.Color.Neutrals.Gray, name: 'chevron---left' }) })] }) })] }));
};
//# sourceMappingURL=ToolBar.js.map